import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { UrgentBar } from "./UrgentBar";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { track } from "@/lib/api";

export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    track("pageview", pathname);
  }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-50 btn-primary" data-testid="skip-to-content">Skip to main content</a>
      <UrgentBar />
      <SiteHeader />
      <main id="main" className="flex-1" tabIndex={-1}>
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
